export function createBirthdayCode(dob) {
  const [day, month, year] = dob.split('/');
  return year.slice(-2) + month + day;
}
